import React, { memo, forwardRef } from 'react';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { Card } from 'react-bootstrap';
import { BarChart } from 'echarts/charts';
import {
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { useAppContext } from '../../../providers/AppProvider';

echarts.use([
  BarChart,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  CanvasRenderer
]);

const getChartOptions = (theme, getThemeColor, shiftData) => {
  const shifts = Object.keys(shiftData || {}); // X-axis categories (shifts)

  // TV FLAT MAT NOW WORKING
  // const machines = Array.from(
  //   new Set(
  //     shifts.flatMap(shift => Object.keys(shiftData[shift])) // Unique machines across all shifts
  //   )
  // );
  const machines = Array.from(
    new Set(
      shifts
        .map(shift => Object.keys(shiftData[shift])) // Map each shift to its machine keys
        .flat() // Flatten the resulting arrays into a single array
    )
  );
  // Define a color palette for the machines
  const colorPalette = machines.reduce((acc, machine, index) => {
    acc[machine] =
      theme === 'dark'
        ? `hsl(${index * 40}, 70%, 50%)` // Vibrant colors for dark theme
        : `hsl(${index * 40}, 50%, 60%)`; // Softer colors for light theme
    return acc;
  }, {});

  // Prepare series
  const series = machines.map(machine => ({
    name: machine,
    type: 'bar',
    stack: machine, // Keep stacks per machine for grouping
    data: shifts.map(shift => shiftData[shift]?.[machine] || 0), // Zero if no data for machine in shift
    label: {
      show: true,
      position: 'top',
      formatter: () => machine, // Display machine name on top of the bar
      color: getThemeColor('gray-800'),
      fontSize: 9,
      rotate: 90, // vertical — incap 8 masini fara sa se suprapuna numele
      align: 'left',
      verticalAlign: 'middle'
    },
    itemStyle: {
      color: colorPalette[machine] // Assign unique color to each machine
    },
    barMaxWidth: 10,
    barGap: '20%'
  }));

  return {
    tooltip: {
      trigger: 'item',
      formatter: ({ seriesName, value, name }) =>
        `<strong>${name}</strong><br>${seriesName}: ${value.toFixed(2)} km`
    },
    legend: {
      data: machines,
      textStyle: {
        fontSize: 12,
        color: getThemeColor('gray-800')
      },
      bottom: 0
    },
    xAxis: {
      type: 'category',
      data: shifts, // Shifts on x-axis
      axisLabel: {
        fontSize: 12,
        color: getThemeColor('gray-800')
      },
      axisLine: {
        lineStyle: {
          color: getThemeColor('gray-300')
        }
      },
      axisTick: {
        alignWithLabel: true
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontSize: 12,
        formatter: '{value} km',
        color: getThemeColor('gray-800')
      },
      axisLine: {
        lineStyle: { color: getThemeColor('gray-300') }
      },
      splitLine: {
        show: true,
        lineStyle: { color: getThemeColor('gray-300') }
      }
    },
    series,
    grid: {
      left: '10%',
      right: '10%',
      bottom: '22%', // legenda cu 8 masini se rupe pe doua randuri
      top: '15%', // loc pentru numele rotite deasupra barelor
      containLabel: true
    }
  };
};

const ShiftTotalProducedChart = forwardRef(({ shiftData, title }, ref) => {
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  console.log('REPAINTED ');
  return (
    <Card className="h-100">
      <Card.Body>
        <div style={styles.headerContainer}>
          <div style={styles.title}>{title}</div>
        </div>
        <ReactEChartsCore
          ref={ref}
          echarts={echarts}
          option={getChartOptions(theme, getThemeColor, shiftData)}
          style={{ height: '400px', width: '100%' }}
        />
      </Card.Body>
    </Card>
  );
});

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px'
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333'
  }
};

export default memo(ShiftTotalProducedChart);
